import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import Row from "../../../shared/components/Row";
import Card from "../../../shared/components/Card";
import CardHeader from "../../../shared/components/card-header/CardHeader";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import HeaderSearchRefreshFilterOptions from "../../../shared/components/HeaderSearchRefreshFilterOptions";
import CardBody from "../../../shared/components/CardBody";
import Paginator from "../../../shared/components/Paginator";
import CompanyAutocomplete from "../../../shared/components/CompanyAutocomplete";
import ConstructionAutocomplete from "../../../shared/components/ConstructionAutocomplete";
import Select from "../../../shared/components/Select";
import {bindActionCreators} from "redux";
import * as monthlyActions from "../actions/monthlyActions";
import MonthlyTable from "./MonthlyTable";

class MonthlyCard extends React.Component {

    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onChangeWorkCheckType = this.onChangeWorkCheckType.bind(this);
        this.onChangeWorkCheckTypeAll = this.onChangeWorkCheckTypeAll.bind(this);
        this.onSortByColumn = this.onSortByColumn.bind(this);

        this.state = {
            page: 1,
            search: '',
            construction: null,
            year: -1,
            month: -1,
            company: null,
        };
    }

    componentWillMount() {
        this.getYears();
        this.getWorkCheckStates();

        // Provisional
        // this.props.monthlyActions.getWorkChecks(34, 2018, 12, 12, "", 1);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page || prevState.search !== this.state.search) {
            this.getWorkChecks();
        }
        if (prevState.construction !== this.state.construction) {
            // No se hace nada ahora
            if (this.state.year !== -1 && this.state.month !== -1 && this.state.company !== null) {
                this.getWorkChecks();
            }
        }
        if (prevState.year !== this.state.year && this.state.year !== -1) {
            this.getMonths();
        }
        if (prevState.month !== this.state.month) {
        }
        if (prevState.company !== this.state.company) {
            this.getWorkChecks();
        }
    }

    getWorkChecks() {
        const {monthlyActions} = this.props;
        const {
            year,
            month,
            company,
            construction,
            search,
            page,
        } = this.state;

        if (year !== -1 && month !== -1 && company !== null) {
            monthlyActions
                .getWorkChecks(
                    construction ? construction.id : null,
                    year,
                    month,
                    company.id,
                    search,
                    page,
                );
        }
    }

    getYears() {
        this.props.monthlyActions.getYears(this.state.construction ? this.state.construction.id : null);
    }

    getMonths() {
        this.props.monthlyActions.getMonths(this.state.construction ? this.state.construction.id : null, this.state.year);
    }

    getWorkCheckStates() {
        this.props.monthlyActions.getWorkCheckStates();
    }

    onRefresh() {
        this.getWorkChecks();
    }

    onSearch(search) {
        this.setState({search: search, page: 1});
    }

    onPage(page) {
        this.setState({page})
    }

    onSortByColumn(columnSortedSelected) {
        this.props.monthlyActions.sortWorkChecks(columnSortedSelected);
    }

    onChangeWorkCheckType(workerId, workCheckTypeId, workCheckStateId) {
        this.props.monthlyActions.saveWorkCheckType(
            this.state.construction ? this.state.construction.id : null,
            this.state.year,
            this.state.month,
            this.state.company.id,
            workerId,
            workCheckTypeId,
            workCheckStateId
        )
    }

    onChangeWorkCheckTypeAll(workCheckTypeId, workCheckStateId) {
        const workerIds = Object.keys(this.props.workers).map((workerId) => workerId);
        this.props.monthlyActions.saveWorkCheckTypeBatch(
            this.state.construction ? this.state.construction.id : null,
            this.state.year,
            this.state.month,
            this.state.company.id,
            workerIds,
            workCheckTypeId,
            workCheckStateId
        );
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                enableFilter={false}
            />
        );
    }

    renderHeaderFilterOptions() {
        return (
            <div className="row">
                <div className="col-sm-3">
                    <label>Obra:</label>
                    <ConstructionAutocomplete
                        constructions={this.state.construction}
                        onChange={(value) => {
                            if (value && value[0]) {
                                this.setState({
                                    construction: value[0],
                                    // year: -1,
                                    // month: -1,
                                    // company: null
                                });
                                this.props.monthlyActions.clearWorkChecks();
                            } else {
                                this.setState({construction: null});
                                this.props.monthlyActions.clearWorkChecks();
                            }
                        }}
                    />
                </div>
                <div className="col-sm-3">
                    <label>Año:</label>
                    <Select
                        className="form-control show-tick bootstrap-select"
                        options={this.props.monthlyYears}
                        value={this.state.year}
                        disabled={false}
                        onChange={(event) => {
                            this.setState({
                                year: parseInt(event.target.value, 0),
                                month: -1,
                                company: null
                            });
                            this.props.monthlyActions.clearWorkChecks();
                        }}
                    />
                </div>
                <div className="col-sm-3">
                    <label>Mes:</label>
                    <Select
                        className="form-control show-tick bootstrap-select"
                        options={this.props.monthlyMonths}
                        value={this.state.month}
                        disabled={this.state.year === -1}
                        onChange={(event) => {
                            this.setState({
                                month: parseInt(event.target.value, 0),
                                company: null
                            });
                            this.props.monthlyActions.clearWorkChecks();
                        }}
                    />
                </div>
                <div className="col-sm-3">
                    <label>Subcontrata:</label>
                    <CompanyAutocomplete
                        id={'MONTHLY_COMPANY_AUTOCOMPLETE'}
                        company={this.state.company}
                        disabled={this.state.year === -1 || this.state.month === -1}
                        onChange={(value) => {
                            if (value && value[0]) {
                                this.setState({company: value[0]});
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    renderTable() {
        const {
            year,
            month,
            company,
        } = this.state;

        if (year !== -1 && month !== -1 && company !== null) {

            const {
                days,
                loading,
                dayChecksByWorker,
                monthChecksByWorker,
                workCheckTypes,
                workCheckStates,
                workersSorted,
                columnSortedSelected,
                columnSortAsc,
            } = this.props;

            if (loading) return null;

            return (
                <MonthlyTable
                    days={days}
                    columnSortAsc={columnSortAsc}
                    dayChecksByWorker={dayChecksByWorker}
                    columnSortedSelected={columnSortedSelected}
                    showDocumentsOfWorker={false}
                    workers={workersSorted}
                    monthChecksByWorker={monthChecksByWorker}
                    workCheckTypes={workCheckTypes}
                    workCheckStates={workCheckStates}
                    onChangeWorkCheckType={this.onChangeWorkCheckType}
                    onChangeWorkCheckTypeAll={this.onChangeWorkCheckTypeAll}
                    onSortByColumn={this.onSortByColumn}
                />
            );
        }
        return <h4 className={'text-center'}>Seleccione los parametros de búsqueda</h4>;
    }

    render() {
        return (
            <Row>
                <Card loading={this.props.loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TRABAJADORES').toUpperCase()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <div>
                            {this.renderHeaderFilterOptions()}
                            <hr/>
                            {this.renderTable()}
                        </div>
                    </CardBody>
                    <Paginator onPage={this.onPage} data={this.props.pagination}/>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {

    let user;
    if (state.auth.user) {
        user = state.auth.user.roles[0].role.id;
    }

    return ({
        userRol: user,
        monthlyYears: state.monthly.years,
        monthlyMonths: state.monthly.months,
        workCheckStates: state.monthly.workCheckStates,
        workCheckTypes: state.monthly.workCheckTypes,
        days: state.monthly.days,
        workers: state.monthly.workers,
        workersSorted: state.monthly.workersSorted,
        dayChecksByWorker: state.monthly.dayChecksByWorker,
        monthChecksByWorker: state.monthly.monthChecksByWorker,
        loading: state.monthly.monthlyLoading,
        error: state.monthly.monthlyError,
        pagination: state.monthly.monthlyPagination,
        columnSortedSelected: state.monthly.columnSortedSelected,
        columnSortAsc: state.monthly.columnSortAsc,
    });
};

const mapDispatchToProps = dispatch => ({
    monthlyActions: bindActionCreators(monthlyActions, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(MonthlyCard);

MonthlyCard.propTypes = {
    companyId: PropTypes.string
};

MonthlyCard.defaultProps = {
    companyId: null
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/components/MonthlyCard.js